module.exports = " <div class=\"product\" (click)=\"openScene(); product.displayTooltip()\" [ngClass]=\"{'is-in-cart': product.isAddedToCart, highlighted: product.tooltipIsVisible || product.tooltipIsHovered }\" *ngFor=\"let product of _catProdsInCart\"> <div class=\"info clearfix\"> <div class=\"name left\">{{product.name}}{{product.getNameTags()}}</div> <div class=\"price right\">${{product.getPrice()}}</div> </div> <div class=\"remove\" (click)=\"product.removeFromCart()\"></div> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/catalog/shared/components/products/products-tiny-list.cmp.html
// module id = 854
// module chunks = 1